module.exports = __webpack_public_path__ + "img/log_2A.9ca5937a.png";